import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { ILinkProps } from '.';

export const generate = (
  props?: Partial<IComponentSchema<ILinkProps>>
): IComponentSchema<ILinkProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.STRING,
    name: props?.name || id,
    title: props?.title || 'Link',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.Link,
    'x-component-props': {
      text: 'Link',
      href: '',
      target: '',
      visible: true,
    },
    'x-component-props-config': {},
  };
};
